import tmhRequest from '@/config/tmhRequest'

export default {

    searchCouponOrderCount: function (data) {
        return tmhRequest({
            url: '/order/tmh/couponorder/searchcouponordercount',
            method: 'post',
            data: data,
        })
    },
    searchCouponOrderByPage: function (data) {
        return tmhRequest({
            url: '/order/tmh/couponorder/searchcouponorderbypage',
            method: 'post',
            data: data,
        })
    },

    searchTargetCoupon: function (data) {
        return tmhRequest({
            url: '/order/tmh/couponorder/searchtargetcoupon',
            method: 'post',
            params: data,
        })
    },

    createMeiTuanOrder: function (data) {
        return tmhRequest({
            url: '/order/tmh/couponorder/createmeituanorder',
            method: 'post',
            params: data,
        })
    },

    multiCreateMeiTuanOrder: function (data) {
        return tmhRequest({
            url: '/order/tmh/couponorder/multicreatemeituanorder',
            method: 'post',
            data: data,
        })
    },

    closeCouponOrder: function (data) {
        return tmhRequest({
            url: '/order/tmh/couponorder/closecouponorder',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/order/couponorder.js